import { render } from "./ProfileBackedCampaignDetail.vue?vue&type=template&id=b00589bc"
import script from "./ProfileBackedCampaignDetail.vue?vue&type=script&lang=js"
export * from "./ProfileBackedCampaignDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__